import React, { useState } from "react"

import { Link, useParams } from "react-router-dom"

import { Heading } from "@chakra-ui/core"
import { ChevronLeftIcon } from "@heroicons/react/24/solid"

import Paginator from "~tailwindui/Table/Paginator"

import { gql, useClient, useQuery } from "hooks/urql"

import Message from "components/LegacyMessageThreads/Details/Message"
import NotificationContainer from "components/NotificationContainer"
import Layer from "components/Pages/Layer"
import UrqlLoadingIndicator from "components/WithLoadingIndicator/urql"

const ThreadArchive = () => {
  const client = useClient()
  const params: any = useParams()
  const [page, setPage] = useState(1)
  const [result] = useQuery({
    query: messageThreadQuery,
    variables: { id: params.threadId, page },
    client,
  })

  return (
    <Layer>
      <Link
        to="/messages"
        className="mb-4 flex max-w-max rounded-md p-2 pl-0 hover:bg-gray-200"
      >
        <ChevronLeftIcon className="h-6 text-gray-300" />
        <span>Back to Thread</span>
      </Link>

      <UrqlLoadingIndicator result={result}>
        {({ data: { viewer } }) => (
          <>
            <NotificationContainer />
            <Heading fontSize="xl" maxW="50%" isTruncated my="6">
              {viewer.messageThread.title} Messages
            </Heading>

            {viewer.messageThread.messages.data.map(message => (
              <Message key={message.id} message={message} viewer={viewer} />
            ))}
            <Paginator
              totalPages={viewer.messageThread.messages.totalPages}
              currentPage={page}
              changePage={setPage}
            />
          </>
        )}
      </UrqlLoadingIndicator>
    </Layer>
  )
}

const messageThreadQuery = gql`
  query MessageThread($id: ID!, $page: Int) {
    viewer {
      id
      type
      messageThread(id: $id) {
        id
        title
        users {
          id
          messagingDisplayName
          avatar {
            thumbUrl
          }
        }
        messages(page: $page) {
          totalPages
          data {
            id
            content
            createdAt
            author {
              id
              messagingDisplayName
              avatar {
                thumbUrl
              }
            }
            attachment {
              filename
              contentType
              downloadUrl
              url
              thumbUrl
              previewUrl
            }
          }
        }
      }
    }
  }
`

export default ThreadArchive
